import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Email } from '../model/email.model';
import { UserLoginModel } from '../model/user-login-model';
import { PoheaderService } from '../services/poheader.service';
import { CrudService } from '../services/crud.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  UserName: any;
  UserRole: any;
  EmailModel: Email = new Email();
  ForgotPassModel: UserLoginModel = new UserLoginModel();
  Newpassword: any = "";
  DisableResetButton: boolean = false;

  constructor(private route: ActivatedRoute,
    private router: Router, private toasterSer: ToastrService, private POHeaderSer: PoheaderService, public crudSer:CrudService) { }

  ngOnInit() {
    this.UserName = sessionStorage.getItem("UserName");
    this.UserRole = sessionStorage.getItem("UserRole").toLowerCase();

  }
  validateForgotPassword(): boolean {
    var result: boolean = false;
    if (this.ForgotPassModel.USER_PASSWORD == "" || this.ForgotPassModel.USER_PASSWORD == undefined || this.ForgotPassModel.USER_PASSWORD == null) {
      this.toasterSer.warning("Please enter Old Password");
      result = true;
    }
    if (this.ForgotPassModel.USER_CONFIRM_PASSWORD == "" || this.ForgotPassModel.USER_CONFIRM_PASSWORD == undefined || this.ForgotPassModel.USER_CONFIRM_PASSWORD == null) {
      this.toasterSer.warning("Please enter New Password");
      result = true;
    }

    if (this.Newpassword == "" || this.Newpassword == undefined || this.Newpassword == null) {
      this.toasterSer.warning("Please enter confirm Password");
      result = true;
    }
    if (this.Newpassword != this.ForgotPassModel.USER_CONFIRM_PASSWORD) {
      this.toasterSer.warning("Password does not match");
      result = true;
    }
    if (this.Newpassword == this.ForgotPassModel.USER_PASSWORD) {
      this.toasterSer.warning("Old password and new password can not be same");
      result = true;
    }
    return result;

  }

  ResetPassword() {   
    if (!this.validateForgotPassword()) {
      this.DisableResetButton=true;
      this.POHeaderSer.ResetPassword(this.UserName, this.ForgotPassModel.USER_PASSWORD, this.Newpassword).subscribe(
        data => {
          if (data.Status) {
            this.DisableResetButton=false;
            this.toasterSer.success(data.Message);
            this.ForgotPassModel=new UserLoginModel();
       this.Newpassword="";
            this.LogOut();
          }
          else {
            this.DisableResetButton=false;
            this.toasterSer.error(data.Message)
          }
        },
        error => {
          this.DisableResetButton=false;
          console.log(error);
          console.error();
        }
      );
    }

  }
  ClearModalPopUP() {
    this.ForgotPassModel = new UserLoginModel();
  }
  validate() {
    if (this.EmailModel.Name == '') {
      this.toasterSer.warning("Please enter name");
      return false;

    }
    if (this.EmailModel.ContactNumber == '') {
      this.toasterSer.warning("Please enter Mobile Number");
      return false;

    }
    if (this.EmailModel.Email == '') {
      this.toasterSer.warning("Please enter Email");
      return false;
    }
    if (this.EmailModel.UserQuery == '') {
      this.toasterSer.warning("Please enter Query");
      return false;
    }
    else {
      return true;
    }
  }
  SendEmail() {
    if (!(this.validate())) {
      return;
    }
    if (!(this.validateEmail())) {
      this.toasterSer.error("Email address is invalid");
      return;
    }
    this.EmailModel.Subject = this.UserName;
    this.POHeaderSer.SendEmail(this.EmailModel).subscribe(
      res => {
        if (res.Status) {
          this.ResetModalPopUp();
          this.toasterSer.success(res.Message);
        }
        else {
          this.toasterSer.error(res.Message);
        }
      },
      error => {
        console.log(error);
        console.error();
      }
    );

  }


  validateEmail() {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(this.EmailModel.Email).toLowerCase());

  }
  ResetModalPopUp() {
    this.EmailModel = new Email();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  LogOut(){
    sessionStorage.setItem("UserName","");
    sessionStorage.setItem("UserRole","");
    sessionStorage.setItem("UserEmail","");
    sessionStorage.setItem("notice","");
    sessionStorage.clear();
    location.href="/";
 // this.router.navigate(['/signin']);
  }

}
